/* src/components/datagrid/CustomToolbar.jsx - Última MOdificación: 26-12-2025 */
/* --------------------------------------------------------------------------- */

import React from "react";
import {
  alpha,
  InputAdornment,
  useTheme,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

export function CustomToolbar() {
  const theme = useTheme();
  const ui = theme.custom.ui;

  return (
    <GridToolbarContainer
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 2,

        display: "flex",
        alignItems: "center",

        px: 2,
        py: 1,

        backgroundColor: ui.surfaceBg,
        borderBottom: `1px solid ${ui.borderSubtle}`,

        backdropFilter: "blur(6px)",
      }}
    >
      <GridToolbarQuickFilter
        debounceMs={300}
        placeholder="Buscar…"
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon
                  sx={{
                    fontSize: 18,
                    color: ui.textMuted,
                  }}
                />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          minWidth: 260,

          "& .MuiInputBase-root": {
            fontSize: "0.85rem",
            backgroundColor: alpha(ui.modalBg, 0.9),
            color: ui.textPrimary,

            "&:hover": {
              backgroundColor: alpha(ui.modalBg, 1),
            },

            "&.Mui-focused": {
              boxShadow: `0 0 0 2px ${alpha(ui.focus, 0.35)}`,
            },
          },

          "& input::placeholder": {
            color: ui.textMuted,
            opacity: 1,
          },
        }}
      />
    </GridToolbarContainer>
  );
}
